export const iconPaths = {
  // === Navigation ===
  home: ['M3 10.5 12 3l9 7.5', 'M5 9.5V21h5v-6h4v6h5V9.5'],
  'chevron-left': ['M15 6l-6 6 6 6'],
  'chevron-right': ['M9 18l6-6-6-6'],
  'chevron-up': ['M18 15l-6-6-6 6'],
  'chevron-down': ['M6 9l6 6 6-6'],
  'arrow-left': ['M19 12H5', 'M12 19l-7-7 7-7'],
  'arrow-right': ['M5 12h14', 'M12 5l7 7-7 7'],
  'arrow-up': ['M12 19V5', 'M5 12l7-7 7 7'],
  'arrow-down': ['M12 5v14', 'M19 12l-7 7-7-7'],
  'arrow-up-right': ['M7 17L17 7', 'M7 7h10v10'],
  'arrow-down-left': ['M17 7L7 17', 'M17 17H7V7'],
  'arrow-down-right': ['M7 7l10 10', 'M17 7v10H7'],
  'arrow-up-left': ['M17 17L7 7', 'M17 7H7v10'],
  'back': ['M19 12H9', 'M14 7l-5 5 5 5'],
  'forward': ['M5 12h10', 'M10 7l5 5-5 5'],
  'skip-back': ['M19 20V4l-8 8 8 8', 'M5 19h4V5H5z'],
  'skip-forward': ['M5 4v16l8-8-8-8', 'M15 5h4v14h-4z'],
  'triangle-right': ['M6 4 L15 13 L6 22'],
  'triangle-down': ['M4 6 L13 15 L22 6'],
  'triangle-left': ['M18 4L9 13l9 9'],
  'triangle-up': ['M4 18l9-9 9 9'],

  // === Media ===
  play: ['M6 4l12 8-12 8z'],
  pause: ['M6 4h4v16H6z', 'M14 4h4v16h-4z'],
  stop: ['M6 6h12v12H6z'],
  record: ['M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16z', 'M12 8a4 4 0 1 1 0 8 4 4 0 0 1 0-8z'],
  volume: ['M11 5L6 9H2v6h4l5 4V5z', 'M15.54 8.46a5 5 0 0 1 0 7.07'],
  'volume-mute': ['M11 5L6 9H2v6h4l5 4V5z', 'M19 12l-6-6', 'M13 18l6-6'],
  music: ['M9 18V5l10-2v13', 'M7 18a2 2 0 1 0 4 0 2 2 0 0 0-4 0z', 'M17 16a2 2 0 1 0 4 0 2 2 0 0 0-4 0z'],
  video: ['M23 7l-7 5v10l7-5V7z', 'M3 5h8v14H3z'],
  camera: ['M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z', 'M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6z'],

  // === File Operations ===
  file: ['M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z', 'M14 3v6h6'],
  'file-text': ['M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z', 'M14 3v6h6', 'M8 13h8', 'M8 17h5'],
  'file-code': ['M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z', 'M14 3v6h6', 'M9 14l-2 2 2 2', 'M15 14l2 2-2 2'],
  'file-pdf': ['M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z', 'M14 3v6h6', 'M8 13c1-2 3-3 5-2'],
  'file-zip': ['M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z', 'M14 3v6h6', 'M10 13h4', 'M10 17h4'],
  'file-audio': ['M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z', 'M14 3v6h6', 'M8 14a3 3 0 0 1 8 0'],
  'file-video': ['M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z', 'M14 3v6h6', 'M8 13l2-2 2 2 2-2 2 2'],
  'file-image': ['M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z', 'M14 3v6h6', 'M8 15l2-2 2 2 2-3 3 4H7z'],
  copy: ['M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2', 'M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-2', 'M8 8h8v8H8z'],
  paste: ['M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2', 'M9 8h6', 'M9 12h8', 'M9 16h5'],
  cut: ['M6 6l12 12', 'M18 6L6 18', 'M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6z', 'M16 20a3 3 0 1 0 0-6 3 3 0 0 0 0 6z'],
  'new-icon': ['M12 5v14', 'M5 12h14'],

  // === System ===
  power: ['M18.36 5.64a9 9 0 1 1-12.72 0', 'M12 2v10'],
  logout: ['M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4', 'M16 17l5-5-5-5', 'M12 12h9'],
  sleep: ['M12 3a9 9 0 1 0 9 9', 'M12 3v4'],
  restart: ['M21 12a9 9 0 1 1-15.3 6.4L3 16', 'M3 21v-5h5', 'M3 12A9 9 0 0 1 18.3 5.6L21 8', 'M21 3v5h-5'],
  battery: ['M1 6h18v12H1z', 'M21 10v4'],
  'battery-charging': ['M1 6h18v12H1z', 'M21 10v4', 'M10 15l2-3 2 2 2-4'],
  wifi: ['M5 12.5a9 9 0 0 1 14 0', 'M7.5 15a5 5 0 0 1 9 0', 'M10 17.5a2 2 0 0 1 4 0'],
  'wifi-off': ['M1 1l22 22', 'M5 12.5a9 9 0 0 1 14 0', 'M7.5 15a5 5 0 0 1 9 0'],
  bluetooth: ['M7 7l10 10-5 5V17l-5 5'],
  signal: ['M2 20h2v-3H2z', 'M6 20h2v-6H6z', 'M10 20h2v-9H10z', 'M14 20h2v-12H14z', 'M18 20h2v-15H18z'],
  cpu: ['M4 4h16v16H4z', 'M9 9h6v6H9z', 'M9 1v3', 'M15 1v3', 'M9 20v3', 'M15 20v3', 'M1 9h3', 'M1 15h3', 'M20 9h3', 'M20 15h3'],
  memory: ['M6 4h12v16H6z', 'M9 8h6', 'M9 12h6', 'M9 16h6'],
  disk: ['M6 4h12v16H6z', 'M9 8h6', 'M12 8v8'],

  // === Social ===
  github: ['M12 2A10 10 0 0 0 2 12c0 4.4 2.9 8.1 6.9 9.4.5.1.7-.2.7-.5v-2c-2.8.6-3.4-1.3-3.4-1.3-.5-1.1-1.1-1.4-1.1-1.4-1.5-1 .1-1 .1-1 1.6.1 2.5 1.7 2.5 1.7 1.5 2.5 3.9 1.8 4.9 1.4.1-1.1.6-1.8 1.1-2.2-2.2-.3-4.6-1.1-4.6-5 0-1.1.4-2 1.1-2.7-.1-.3-.5-1.3.1-2.7 0 0 .9-.3 2.8 1a9.7 9.7 0 0 1 5 0c1.9-1.3 2.8-1 2.8-1 .6 1.4.2 2.4.1 2.7.7.7 1.1 1.6 1.1 2.7 0 3.9-2.4 4.7-4.6 5 .7.6 1.3 1.8 1.3 3.6v5.3c0 .3.2.6.7.5A10 10 0 0 0 22 12 10 10 0 0 0 12 2z'],
  twitter: ['M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z'],
  facebook: ['M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z'],
  linkedin: ['M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z', 'M9 3h4v12H9z', 'M7 3h4v12H7z'],
  mail: ['M4 4h16v16H4z', 'M4 6l8 6 8-6'],
  phone: ['M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z'],
  message: ['M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z'],
  chat: ['M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z', 'M3 9h18'],

  // === UI ===
  spinner: ['M12 3v4', 'M12 17v4', 'M4 12h4', 'M16 12h4', 'M6.3 6.3l2.8 2.8', 'M14.9 14.9l2.8 2.8', 'M17.7 6.3l-2.8 2.8', 'M9.1 14.9l-2.8 2.8'],
  loader: ['M12 3a9 9 0 1 0 9 9', 'M12 3v4'],
  'dots-horizontal': ['M5 12h.01', 'M12 12h.01', 'M19 12h.01'],
  'dots-vertical': ['M12 5h.01', 'M12 12h.01', 'M12 19h.01'],
  grip: ['M8 6h.01', 'M8 12h.01', 'M8 18h.01', 'M16 6h.01', 'M16 12h.01', 'M16 18h.01'],
  handle: ['M8 6h.01', 'M8 12h.01', 'M8 18h.01', 'M16 6h.01', 'M16 12h.01', 'M16 18h.01'],
  drag: ['M8 6h.01', 'M8 12h.01', 'M8 18h.01', 'M16 6h.01', 'M16 12h.01', 'M16 18h.01'],
  'maximize-2': ['M8 3H5a2 2 0 0 0-2 2v3', 'M21 3v3a2 2 0 0 1-2 2H16', 'M3 21v-3a2 2 0 0 1 2-2h3', 'M21 21v-3a2 2 0 0 0-2-2h-3'],
  'minimize-2': ['M8 3v5a2 2 0 0 1-2 2H3', 'M21 8h-5a2 2 0 0 1-2-2V3', 'M3 16h5a2 2 0 0 1 2 2v5', 'M21 16h-5a2 2 0 0 0-2 2v5'],
  close: ['M6 6l12 12', 'M18 6 6 18'],
  minimize: ['M5 12h14'],
  maximize: ['M6 6h12v12H6z'],
  restore: ['M8 8h10v10H8z', 'M6 16H5V5h11v1'],
  'window-minimize': ['M7 16h10'],
  'window-maximize': ['M8 8h8v8H8z'],
  'window-restore': ['M9 10h7v7H9z', 'M8 14H7V7h7v1'],
  'window-close': ['M8 8l8 8', 'M16 8l-8 8'],

  // === Actions ===
  'external-link': ['M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6', 'M15 3h6v6', 'M10 14l10-10'],
  link: ['M10 13a5 5 0 0 0 7.54.56l1.58-1.57a5 5 0 1 0-7.07-7.07L10.4 6.5', 'M14 11a5 5 0 0 0-7.54-.56L4.88 12a5 5 0 1 0 7.07 7.07l1.58-1.57'],
  unlink: ['M10 13a5 5 0 0 0 7.54.56l1.58-1.57a5 5 0 0 0 0-7.07', 'M14 11a5 5 0 0 0-7.54-.56L4.88 12a5 5 0 0 0 0 7.07', 'M1 1l22 22'],
  share: ['M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8', 'M16 6l-4-4-4 4', 'M12 2v8'],
  'share-2': ['M18 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6z', 'M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z', 'M18 22a3 3 0 1 0 0-6 3 3 0 0 0 0 6z', 'M8.59 13.51l6.83 3.98', 'M15.41 6.51l-6.82 3.98'],

  // === Status ===
  check: ['M20 6 9 17l-5-5'],
  'check-circle': ['M22 11.08V12a10 10 0 1 1-5.93-9.14', 'M22 4L12 14.01l-3-3'],
  'x-circle': ['M22 11.08V12a10 10 0 1 1-5.93-9.14', 'M18 8l-4 4', 'M14 8l4 4'],
  'alert-circle': ['M22 11.08V12a10 10 0 1 1-5.93-9.14', 'M12 8v4', 'M12 16h.01'],
  'help-circle': ['M22 11.08V12a10 10 0 1 1-5.93-9.14', 'M9.09 9a3 3 0 0 1 5.83 1 1 1 0 0 1 0 2.5c-1.46 1.2-2.92 2-2.92 4', 'M12 17h.01'],
  'question-mark': ['M9.09 9a3 3 0 0 1 5.83 1 1 1 0 0 1 0 2.5c-1.46 1.2-2.92 2-2.92 4', 'M12 17h.01'],
  info: ['M12 17v-6', 'M12 7h.01', 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z'],
  warning: ['M12 9v4', 'M12 17h.01', 'M10.3 3.9 2.4 18a2 2 0 0 0 1.7 3h15.8a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z'],
  error: ['M15 9l-6 6', 'M9 9l6 6', 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z'],
  'x-octagon': ['M7.88 3h8.24l4.88 4.88v8.24L16.12 21H7.88L3 16.12V7.88L7.88 3z', 'M15 9l-6 6', 'M9 9l6 6'],

  // === Business ===
  briefcase: ['M6 7h12v14H6z', 'M9 7V4h6v3', 'M3 11h18'],
  building: ['M3 21h18V3H3v18z', 'M9 9h3v3H9V9z', 'M9 14h3v3H9v-3z', 'M14 9h3v3h-3V9z', 'M14 14h3v3h-3v-3z'],
  cart: ['M1 1h4l2.6 11H21l2-7H7.8', 'M6 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4z', 'M17 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4z'],
  'credit-card': ['M2 4h20v16H2z', 'M2 10h20', 'M6 15h4', 'M12 15h6'],
  'dollar-sign': ['M12 1v22', 'M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6'],
  percent: ['M19 5L5 19', 'M9 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4z', 'M15 15a2 2 0 1 0 0-4 2 2 0 0 0 0 4z'],
  tag: ['M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z', 'M7 7h.01'],

  // === Weather ===
  sun: ['M12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10z', 'M12 1v3', 'M12 20v3', 'M4.22 4.22l2.12 2.12', 'M17.66 17.66l2.12 2.12', 'M1 12h3', 'M20 12h3', 'M4.22 19.78l2.12-2.12', 'M17.66 6.34l2.12-2.12'],
  moon: ['M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z'],
  cloud: ['M17.5 19c3.6 0 6.5-2.9 6.5-6.5 0-3.3-2.5-6-5.7-6.4A6.5 6.5 0 0 0 6.5 7 5.5 5.5 0 0 0 6 17.5h11.5z'],
  'cloud-rain': ['M16 13v8', 'M8 13v8', 'M12 15v8', 'M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25'],
  'cloud-snow': ['M8 15l1.5 3', 'M12 15l1.5 3', 'M16 15l1.5 3', 'M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25'],
  'cloud-lightning': ['M13 2L3 14h9l-1 8 10-12h-9l1-8z'],
  thermometer: ['M14 14.7V6a2 2 0 1 0-4 0v8.7A4 4 0 1 0 14 14.7z', 'M12 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z'],

  // === Time ===
  hourglass: ['M5 22h14', 'M5 2h14', 'M7 2v6h10V2', 'M7 22v-6h10v6', 'M7 8l5 4-5 4'],
  timer: ['M10 2h4', 'M12 6v6l4 2', 'M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0z'],
  stopwatch: ['M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z', 'M12 6v6l4 2', 'M10 2h4'],
  clock: ['M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z', 'M12 6v6l4 2'],

  // === Other ===
  globe: ['M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z', 'M2 12h20', 'M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z'],
  'link-2': ['M8 13a5 5 0 0 1 0-7l1.5-1.5a5 5 0 0 1 7 7L15 13a5 5 0 0 1-7 0z', 'M16 13a5 5 0 0 1 0-7l1.5-1.5a5 5 0 0 1 7 7L23 13a5 5 0 0 1-7 0z'],
  chain: ['M10 13a5 5 0 0 0 7.54.56l1.58-1.57a5 5 0 1 0-7.07-7.07L10.4 6.5', 'M14 11a5 5 0 0 0-7.54-.56L4.88 12a5 5 0 1 0 7.07 7.07l1.58-1.57'],
  anchor: ['M12 5v14', 'M5 12h14', 'M12 5a3 3 0 1 0 0-6 3 3 0 0 0 0 6z', 'M5 20h14'],
  bookmark: ['M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z'],
  flag: ['M4 15s1.5-3 4-3 3 3 4 3 4-3 4-3 4 3 4 3V3s-1.5 3-4 3-3-3-4-3-4 3-4 3-4-3-4-3z'],
  gift: ['M20 12v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8', 'M20 12H4', 'M12 2v10', 'M22 12h-4c0-3.3-2.7-6-6-6s-6 2.7-6 6H4'],
  lightbulb: ['M9 21h6v-2H9v2z', 'M12 2a7 7 0 0 0-7 7c0 2 0 3 2 5v2h10v-2c2-2 2-3 2-5a7 7 0 0 0-7-7z'],
  map: ['M1 6v16l6-4 6 4 6-4 4 2V6l-4-2-6 4-6-4-6 4z', 'M9 6v16', 'M15 10v10'],
  navigation: ['M3 11l9-8 9 8-9 8-9-8z', 'M12 13V9'],
  pin: ['M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z', 'M12 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6z'],
  route: ['M6 4h.01', 'M18 20h.01', 'M6 4c0 4 3 6 6 6s6 2 6 6', 'M18 20c0-4-3-6-6-6s-6-2-6-6'],
  send: ['M22 2L11 13', 'M22 2l-7 7-2-2 7-7-7-7 2-2 7 7z'],
  shield: ['M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z'],
  target: ['M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z', 'M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12z', 'M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4z'],
  umbrella: ['M22 12h-4c0-3.3-2.7-6-6-6s-6 2.7-6 6H4c0-3.3 2.7-6 6-6s6 2.7 6 6h2V12h4', 'M12 12v8', 'M8 20h8'],
  zap: ['M13 2L3 14h9l-1 8 10-12h-9l1-8z'],
  user: ['M20 21a8 8 0 0 0-16 0', 'M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z'],
  users: ['M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2', 'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z', 'M23 21v-2a4 4 0 0 0-3-3.87', 'M16 3.13a4 4 0 0 1 0 7.75'],
  folder: ['M3 6.5h6l2 2h10V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6.5z', 'M3 6.5V5a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v1.5'],
  'folder-open': ['M3 6h18v12H3z', 'M3 6l2-2h14l2 2', 'M5 10h14'],
  settings: ['M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z', 'M19.4 15a1.7 1.7 0 0 0 .34 1.87l.06.07a2 2 0 0 1-2.83 2.83l-.07-.06a1.7 1.7 0 0 0-1.87-.34 1.7 1.7 0 0 0-1 1.55V21a2 2 0 0 1-4 0v-.08a1.7 1.7 0 0 0-1-1.55 1.7 1.7 0 0 0-1.87.34l-.07.06a2 2 0 0 1-2.83-2.83l.06-.07A1.7 1.7 0 0 0 4.6 15a1.7 1.7 0 0 0-1.55-1H3a2 2 0 0 1 0-4h.08a1.7 1.7 0 0 0 1.55-1 1.7 1.7 0 0 0-.34-1.87l-.06-.07a2 2 0 0 1 2.83-2.83l.07.06A1.7 1.7 0 0 0 9 4.6a1.7 1.7 0 0 0 1-1.55V3a2 2 0 0 1 4 0v.08a1.7 1.7 0 0 0 1 1.55 1.7 1.7 0 0 0 1.87-.34l.07-.06a2 2 0 0 1 2.83 2.83l-.06.07A1.7 1.7 0 0 0 19.4 9c.22.6.83 1 1.55 1H21a2 2 0 0 1 0 4h-.08a1.7 1.7 0 0 0-1.52 1z'],
  search: ['M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15z', 'M16 16l5 5'],
  plus: ['M12 5v14', 'M5 12h14'],
  minus: ['M5 12h14'],
  'x': ['M18 6L6 18', 'M6 6l12 12'],
  refresh: ['M21 12a9 9 0 0 1-15.3 6.4L3 16', 'M3 21v-5h5', 'M3 12A9 9 0 0 1 18.3 5.6L21 8', 'M21 3v5h-5'],
  download: ['M12 3v12', 'M7 10l5 5 5-5', 'M5 21h14'],
  upload: ['M12 21V9', 'M7 14l5-5 5 5', 'M5 3h14'],
  trash: ['M4 7h16', 'M10 11v6', 'M14 11v6', 'M6 7l1 14h10l1-14', 'M9 7V4h6v3'],
  edit: ['M4 20h4L19 9l-4-4L4 16v4z', 'M13 7l4 4'],
  save: ['M5 3h12l2 2v16H5z', 'M8 3v6h8V3', 'M8 21v-7h8v7'],
  lock: ['M7 11V8a5 5 0 0 1 10 0v3', 'M5 11h14v10H5z'],
  unlock: ['M7 11V8a5 5 0 0 1 9.5-2.2', 'M5 11h14v10H5z'],
  calendar: ['M7 3v4', 'M17 3v4', 'M4 8h16', 'M5 5h14a1 1 0 0 1 1 1v15H4V6a1 1 0 0 1 1-1z'],
  menu: ['M4 7h16', 'M4 12h16', 'M4 17h16'],
  star: ['M12 3l2.8 5.7 6.2.9-4.5 4.4 1.1 6.2L12 17.2 6.4 20.2 7.5 14 3 9.6l6.2-.9z'],
  heart: ['M20.8 5.6a5 5 0 0 0-7.1 0L12 7.3l-1.7-1.7a5 5 0 1 0-7.1 7.1L12 21l8.8-8.3a5 5 0 0 0 0-7.1z'],
  window: ['M3 5h18v14H3z', 'M3 9h18', 'M7 7h.01', 'M10 7h.01'],
  cursor: ['M5 3l14 8-6 2.2L15.8 20l-2.8 1.2-2.8-6.8L5 18V3z'],
  'menu-down': ['M7 10l5 5 5-5'],
  square: ['M6 6h12v12H6z'],
  'circle-progress': ['M12 3a9 9 0 1 0 9 9', 'M12 3v4'],
  'radio-button-on': ['M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z', 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z'],
  'toggle-left': ['M8 7h8a5 5 0 0 1 0 10H8A5 5 0 0 1 8 7z', 'M8 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4z'],
  tab: ['M4 6h6l2 4h8v8H4V6z'],
  slider: ['M4 7h10', 'M18 7h2', 'M4 17h2', 'M10 17h10', 'M14 5v4', 'M8 15v4'],
  'text-box': ['M5 4h14v16H5z', 'M8 8h8', 'M8 12h8', 'M8 16h5'],
  bell: ['M6 9a6 6 0 1 1 12 0c0 7 3 7 3 9H3c0-2 3-2 3-9z', 'M10 21h4'],
  list: ['M8 6h12', 'M8 12h12', 'M8 18h12', 'M4 6h.01', 'M4 12h.01', 'M4 18h.01'],
  hamburger: ['M4 7h16', 'M4 12h16', 'M4 17h16'],
  tree: ['M12 4v6', 'M8 10h8', 'M8 10v6', 'M16 10v6', 'M6 20h4v-4H6z', 'M14 20h4v-4h-4z'],
  columns: ['M4 5h16v14H4z', 'M12 5v14'],
  desktop: ['M3 5h18v12H3z', 'M9 21h6', 'M12 17v4'],
  'dock-bottom': ['M4 4h16v16H4z', 'M4 15h16'],
  windows: ['M4 5l7-1v8H4z', 'M13 4l7-1v9h-7z', 'M4 14h7v6l-7-1z', 'M13 14h7v7l-7-1z'],
  'context-menu': ['M5 7h14', 'M5 12h14', 'M5 17h8', 'M17 17h.01'],
  scroll: ['M7 4h10a2 2 0 0 1 2 2v12a3 3 0 0 1-3 3H7a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z', 'M9 8h6', 'M9 12h6', 'M9 16h4'],
  tools: ['M14.7 6.3l3-3 3 3-3 3', 'M4 20l7-7', 'M13 5l6 6'],
  eye: ['M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z', 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z'],
  'eye-off': ['M3 3l18 18', 'M10.6 10.6a2 2 0 0 0 2.8 2.8', 'M9.9 4.2A10.8 10.8 0 0 1 12 4c6 0 10 8 10 8a17.2 17.2 0 0 1-3.2 4.2', 'M6.1 6.1C3.6 8 2 12 2 12s4 8 10 8c1.5 0 2.8-.4 4-1'],
  button: ['M4 4h16v16H4z', 'M8 8h10v10H8z'],
  input: ['M4 6h16v12H4z', 'M8 10h10M8 14h6'],
} as const

export type IconName = keyof typeof iconPaths

export const iconNames = Object.keys(iconPaths) as IconName[]
